var map = {
	"./2CAD.svg": 720,
	"./2JPY.svg": 721,
	"./2NZD.svg": 722,
	"./2OMB.png": 723,
	"./2SGD.png": 724,
	"./2SHARES.png": 725,
	"./4EUR.png": 726,
	"./AAVE.svg": 727,
	"./AAVEe.svg": 728,
	"./ACRE.png": 729,
	"./ADA.svg": 730,
	"./ADX.svg": 731,
	"./ALI.svg": 732,
	"./ALPACA.png": 733,
	"./ALPHA.png": 734,
	"./AMPL.png": 735,
	"./ANN.png": 736,
	"./ANY.png": 737,
	"./AOT.png": 738,
	"./APE.png": 739,
	"./ARBITRUM.svg": 740,
	"./ATLAS.png": 741,
	"./ATOM.png": 742,
	"./AURO.png": 743,
	"./AURORA.svg": 744,
	"./AVALANCHE.svg": 745,
	"./AVAX.png": 746,
	"./AVAX.svg": 747,
	"./AVAXL.svg": 748,
	"./AXS.png": 749,
	"./Andromeda.svg": 750,
	"./BABY.svg": 751,
	"./BABYCAKE.svg": 752,
	"./BAKE.png": 753,
	"./BALL.png": 754,
	"./BANANA.svg": 755,
	"./BASED.svg": 756,
	"./BCH.svg": 757,
	"./BCT.png": 758,
	"./BDO.png": 759,
	"./BDP.png": 760,
	"./BEAR.png": 761,
	"./BEETS.png": 762,
	"./BETA.svg": 763,
	"./BETH.png": 764,
	"./BETU.png": 765,
	"./BHC.png": 766,
	"./BICO.png": 767,
	"./BIFI.png": 768,
	"./BISON.png": 769,
	"./BLZZ.svg": 770,
	"./BMON.svg": 771,
	"./BNB.png": 772,
	"./BNBbsc.png": 773,
	"./BOMB.png": 774,
	"./BONE.png": 775,
	"./BONEswap.png": 776,
	"./BOO.png": 777,
	"./BOOK.png": 778,
	"./BORING.png": 779,
	"./BP.png": 780,
	"./BPT.png": 781,
	"./BREW.png": 782,
	"./BRIBE.png": 783,
	"./BRUSH.png": 784,
	"./BSC.svg": 785,
	"./BSCDEFI.svg": 786,
	"./BSCPAD.png": 787,
	"./BSHARE.svg": 788,
	"./BSTN.svg": 789,
	"./BSW.svg": 790,
	"./BTC.svg": 791,
	"./BTCB.svg": 792,
	"./BTD.png": 793,
	"./BTS.png": 794,
	"./BTT.png": 795,
	"./BUNNY.png": 796,
	"./BURGER.png": 797,
	"./BUSD.svg": 798,
	"./BUSDe.svg": 799,
	"./BUSM.png": 800,
	"./BYTE.png": 801,
	"./CAKE.svg": 802,
	"./CAPS.svg": 803,
	"./CARROT.png": 804,
	"./CCAR.png": 805,
	"./CEEK.png": 806,
	"./CEL.png": 807,
	"./CELO.svg": 808,
	"./CHARGE.png": 809,
	"./CHARM.svg": 810,
	"./CHESS.svg": 811,
	"./CLAM.png": 812,
	"./CLY.png": 813,
	"./COOK.png": 814,
	"./CRA.png": 815,
	"./CRAFT.png": 816,
	"./CRE8R.png": 817,
	"./CREAM.svg": 818,
	"./CRO.svg": 819,
	"./CRONA.svg": 820,
	"./CRONOS.svg": 821,
	"./CRUSH.svg": 822,
	"./CRV.png": 823,
	"./CRYSTL.png": 824,
	"./CTK.png": 825,
	"./CYT.png": 826,
	"./CZF.png": 827,
	"./DAI.png": 828,
	"./DAI.svg": 829,
	"./DAIe.png": 830,
	"./DAR.svg": 831,
	"./DARK.svg": 832,
	"./DBY.png": 833,
	"./DCAU.png": 834,
	"./DEG.png": 835,
	"./DEI.png": 836,
	"./DELIRIUM.png": 837,
	"./DEP.png": 838,
	"./DEUS.png": 839,
	"./DFYN.png": 840,
	"./DG.png": 841,
	"./DIBS.png": 842,
	"./DINO.png": 843,
	"./DIS.svg": 844,
	"./DKT.png": 845,
	"./DOGE.svg": 846,
	"./DOLA.png": 847,
	"./DOMI.png": 848,
	"./DOT.png": 849,
	"./DPI.png": 850,
	"./DPT.png": 851,
	"./DRUGS.png": 852,
	"./DSHARE.png": 853,
	"./DUET.svg": 854,
	"./DVI.svg": 855,
	"./ECD.png": 856,
	"./EGG.png": 857,
	"./ELK.png": 858,
	"./ELON.png": 859,
	"./EMERALD.png": 860,
	"./EMP.png": 861,
	"./EPS.png": 862,
	"./ERA.svg": 863,
	"./ERTHA.png": 864,
	"./ESHARE.png": 865,
	"./EST.png": 866,
	"./ETERNAL.png": 867,
	"./ETH.svg": 868,
	"./ETH2x.png": 869,
	"./ETHs.svg": 870,
	"./EURt.png": 871,
	"./EXP.svg": 872,
	"./EZ.png": 873,
	"./FANTOM.svg": 874,
	"./FET.png": 875,
	"./FFF.png": 876,
	"./FIEF.png": 877,
	"./FIL.svg": 878,
	"./FINN.png": 879,
	"./FIRE.png": 880,
	"./FISH.svg": 881,
	"./FITFI.png": 882,
	"./FLARE.png": 883,
	"./FLX.png": 884,
	"./FLY.png": 885,
	"./FODL.png": 886,
	"./FONT.png": 887,
	"./FOO.png": 888,
	"./FORM.svg": 889,
	"./FOX.png": 890,
	"./FRAX.svg": 891,
	"./FRM.png": 892,
	"./FROYO.png": 893,
	"./FRUIT.png": 894,
	"./FS.png": 895,
	"./FTM.png": 896,
	"./FTML.svg": 897,
	"./FUSE Network.svg": 898,
	"./FUSE.svg": 899,
	"./FXS.png": 900,
	"./G.png": 901,
	"./GAL.png": 902,
	"./GEIST.svg": 903,
	"./GEL.png": 904,
	"./GENESIS.png": 905,
	"./GHST.png": 906,
	"./GLINT.png": 907,
	"./GLMR.png": 908,
	"./GM.png": 909,
	"./GMT.svg": 910,
	"./GMX.png": 911,
	"./GNS.png": 912,
	"./GNT.png": 913,
	"./GOLDCOIN.svg": 914,
	"./GRAPE.png": 915,
	"./GUARD.svg": 916,
	"./HAI.png": 917,
	"./HARD.png": 918,
	"./HARMONY.svg": 919,
	"./HBAR.png": 920,
	"./HBTC.png": 921,
	"./HEC.png": 922,
	"./HECO.svg": 923,
	"./HERO.png": 924,
	"./HIGH.png": 925,
	"./HND.png": 926,
	"./HONEY.png": 927,
	"./HONOR.png": 928,
	"./HOTCROSS.svg": 929,
	"./HPS.png": 930,
	"./HT.png": 931,
	"./HTB.svg": 932,
	"./HUSD.png": 933,
	"./ICA.svg": 934,
	"./ICE.png": 935,
	"./IDIA.svg": 936,
	"./IF.svg": 937,
	"./IME.png": 938,
	"./INCH.png": 939,
	"./INJ.png": 940,
	"./INSUR.png": 941,
	"./INV.png": 942,
	"./IRON.png": 943,
	"./IXT.png": 944,
	"./JETS.png": 945,
	"./JEWEL.png": 946,
	"./JOE.png": 947,
	"./JPYC.png": 948,
	"./JRT.png": 949,
	"./JULD.png": 950,
	"./JUST.png": 951,
	"./KAE.png": 952,
	"./KART.png": 953,
	"./KEBAB.png": 954,
	"./KEK.png": 955,
	"./KIRO.png": 956,
	"./KLIMA.png": 957,
	"./KLO.png": 958,
	"./KRW.png": 959,
	"./LAC.svg": 960,
	"./LAMBDA.svg": 961,
	"./LAND.svg": 962,
	"./LAZIO.png": 963,
	"./LINEAR.svg": 964,
	"./LINK.png": 965,
	"./LINKe.png": 966,
	"./LIQ.png": 967,
	"./LITHIUM.svg": 968,
	"./LONG.png": 969,
	"./LOOT.png": 970,
	"./LOST.png": 971,
	"./LTC.svg": 972,
	"./LUNA.png": 973,
	"./MAGIC.png": 974,
	"./MAI.png": 975,
	"./MAI_Rose.png": 976,
	"./MANA.png": 977,
	"./MARSH.png": 978,
	"./MASK.svg": 979,
	"./MATIC.svg": 980,
	"./MCB.png": 981,
	"./MCRN.svg": 982,
	"./MDX.png": 983,
	"./MEAD.png": 984,
	"./MECHA.png": 985,
	"./MELT.png": 986,
	"./MERL.svg": 987,
	"./METAHERO.svg": 988,
	"./METIS.svg": 989,
	"./MIDAS.png": 990,
	"./MILK.png": 991,
	"./MIM.png": 992,
	"./MOBI.svg": 993,
	"./MONEY.png": 994,
	"./MOON.png": 995,
	"./MOONBEAM.svg": 996,
	"./MOONRIVER.svg": 997,
	"./MORE.png": 998,
	"./MOVR.png": 999,
	"./MSC.png": 1000,
	"./MSS.png": 1001,
	"./MST.png": 1002,
	"./MULTI.png": 1003,
	"./MUST.png": 1004,
	"./MaticX.svg": 1005,
	"./NABOX.png": 1006,
	"./NAOS.png": 1007,
	"./NCASH.png": 1008,
	"./NEAR.svg": 1009,
	"./NETT.png": 1010,
	"./NEXO.png": 1011,
	"./NFT.png": 1012,
	"./NFTY.png": 1013,
	"./NUGGET.svg": 1014,
	"./NUTS.png": 1015,
	"./NYA.png": 1016,
	"./NYAC.png": 1017,
	"./NYAS.png": 1018,
	"./NZDS.png": 1019,
	"./O3.png": 1020,
	"./OASIS.svg": 1021,
	"./OCP.png": 1022,
	"./ONE.svg": 1023,
	"./ONG.svg": 1024,
	"./ONT.png": 1025,
	"./OOE.svg": 1026,
	"./ORBS.svg": 1027,
	"./ORKAN.png": 1028,
	"./OXD.png": 1029,
	"./PACOCA.svg": 1030,
	"./PAE.svg": 1031,
	"./PAE_AVAX.svg": 1032,
	"./PAUTO.png": 1033,
	"./PBNB.png": 1034,
	"./PEAR.svg": 1035,
	"./PEFI.png": 1036,
	"./PERA.png": 1037,
	"./PETS.png": 1038,
	"./PEX.png": 1039,
	"./PHA.png": 1040,
	"./PILLS.png": 1041,
	"./PMP.svg": 1042,
	"./PNG.png": 1043,
	"./POLYGON.svg": 1044,
	"./PORTO.png": 1045,
	"./POTS.png": 1046,
	"./PSP.png": 1047,
	"./PTP.png": 1048,
	"./PUP.png": 1049,
	"./PolyDoge.png": 1050,
	"./QBT.svg": 1051,
	"./QI.png": 1052,
	"./QUICK.png": 1053,
	"./QUIDD.png": 1054,
	"./RABBIT.svg": 1055,
	"./RACA.svg": 1056,
	"./RAMP.png": 1057,
	"./RELAY.png": 1058,
	"./REVV.svg": 1059,
	"./RIB.png": 1060,
	"./ROME.png": 1061,
	"./ROSE.png": 1062,
	"./ROUTE.png": 1063,
	"./RPG.png": 1064,
	"./SAGE.png": 1065,
	"./SAND.png": 1066,
	"./SANTOS.png": 1067,
	"./SBDO.png": 1068,
	"./SCREAM.png": 1069,
	"./SFP.png": 1070,
	"./SFUND.png": 1071,
	"./SHADE.png": 1072,
	"./SHIB.png": 1073,
	"./SHIBX.png": 1074,
	"./SHRAP.png": 1075,
	"./SING.png": 1076,
	"./SISTA.svg": 1077,
	"./SKILL.svg": 1078,
	"./SKY.svg": 1079,
	"./SMART.png": 1080,
	"./SNX.png": 1081,
	"./SOAK.png": 1082,
	"./SOL.png": 1083,
	"./SOLACE.png": 1084,
	"./SOLAR.png": 1085,
	"./SOLID.svg": 1086,
	"./SPADE.png": 1087,
	"./SPELL.png": 1088,
	"./SPIRIT.png": 1089,
	"./SPS.svg": 1090,
	"./STARS.svg": 1091,
	"./START.png": 1092,
	"./STATIC.png": 1093,
	"./STEAK.png": 1094,
	"./STEEL.png": 1095,
	"./STELLA.png": 1096,
	"./STNEAR.png": 1097,
	"./SUMMIT.png": 1098,
	"./SUSHI.png": 1099,
	"./SUSHIe.png": 1100,
	"./SWAMP.svg": 1101,
	"./SX.png": 1102,
	"./SXP.svg": 1103,
	"./SYN.svg": 1104,
	"./TAPE.svg": 1105,
	"./TEL.png": 1106,
	"./TENFI.png": 1107,
	"./TETHYS.svg": 1108,
	"./TETU.svg": 1109,
	"./THG.png": 1110,
	"./TIME.png": 1111,
	"./TITAN.svg": 1112,
	"./TLOS.svg": 1113,
	"./TOMB.png": 1114,
	"./TONIC.svg": 1115,
	"./TOR.svg": 1116,
	"./TREEB.png": 1117,
	"./TRI.svg": 1118,
	"./TRX.png": 1119,
	"./TSHARE.svg": 1120,
	"./TUS.png": 1121,
	"./TUSD.png": 1122,
	"./TYPH.png": 1123,
	"./UFT.png": 1124,
	"./UNI.png": 1125,
	"./UNIe.png": 1126,
	"./USDB.png": 1127,
	"./USDC.svg": 1128,
	"./USDCe.svg": 1129,
	"./USDCm.svg": 1130,
	"./USDCs.svg": 1131,
	"./USDD.png": 1132,
	"./USDL.svg": 1133,
	"./USDO.png": 1134,
	"./USDT.svg": 1135,
	"./USDTe.svg": 1136,
	"./UST.png": 1137,
	"./UST_Rose.png": 1138,
	"./USTaxl.png": 1139,
	"./USTw.png": 1140,
	"./VALAS.svg": 1141,
	"./VERSA.svg": 1142,
	"./VOLT.png": 1143,
	"./VS.svg": 1144,
	"./VTX.png": 1145,
	"./VVS.svg": 1146,
	"./WAN.svg": 1147,
	"./WATCH.png": 1148,
	"./WAULTx.svg": 1149,
	"./WBNB.svg": 1150,
	"./WBTC.svg": 1151,
	"./WBTCe.svg": 1152,
	"./WBTCeth.svg": 1153,
	"./WCRO.svg": 1154,
	"./WETH.svg": 1155,
	"./WETHe.svg": 1156,
	"./WEX.svg": 1157,
	"./WEXpoly.png": 1158,
	"./WIGO.svg": 1159,
	"./WIN.png": 1160,
	"./WINE.png": 1161,
	"./WMATIC.svg": 1162,
	"./WMATIC_DFYN.svg": 1163,
	"./WMOVR_SUSHI.png": 1164,
	"./WOO.svg": 1165,
	"./WOOFY.png": 1166,
	"./WOOP.png": 1167,
	"./WSG.svg": 1168,
	"./WSTA.png": 1169,
	"./WUSD.svg": 1170,
	"./XAVA.png": 1171,
	"./XCV.svg": 1172,
	"./XRP.svg": 1173,
	"./XTZ.png": 1174,
	"./XVS.png": 1175,
	"./XWG.png": 1176,
	"./YAMP.svg": 1177,
	"./YEL.svg": 1178,
	"./YELD.png": 1179,
	"./YETI.png": 1180,
	"./YFI.png": 1181,
	"./YFIe.png": 1182,
	"./YGG.png": 1183,
	"./YOSHI.png": 1184,
	"./YUSD.png": 1185,
	"./YUZU.png": 1186,
	"./ZBTC.svg": 1187,
	"./ZETH.svg": 1188,
	"./ZOO.png": 1189,
	"./aBNBc.png": 1190,
	"./aQI.png": 1191,
	"./aROME.png": 1192,
	"./aUSDO.svg": 1193,
	"./aWOOL.png": 1194,
	"./agEUR.png": 1195,
	"./anyMTLX.png": 1196,
	"./asUSDC.png": 1197,
	"./axlATOM.png": 1198,
	"./bQI.png": 1199,
	"./bZoo.png": 1200,
	"./beFTM.svg": 1201,
	"./beJOE.png": 1202,
	"./beQI.png": 1203,
	"./binSPIRIT.svg": 1204,
	"./bscBUSD.svg": 1205,
	"./cEUR.png": 1206,
	"./cUSD.png": 1207,
	"./cakeHARD.png": 1208,
	"./cakeROOBEE.png": 1209,
	"./cakeSTAX.png": 1210,
	"./cakeTWT.png": 1211,
	"./cakebROOBEE.png": 1212,
	"./ceUSDC.svg": 1213,
	"./cxADA.png": 1214,
	"./cxBTC.png": 1215,
	"./cxDOGE.png": 1216,
	"./cxETH.png": 1217,
	"./evoBTC.svg": 1218,
	"./evoETH.svg": 1219,
	"./evoUSDC.svg": 1220,
	"./evoUSDT.svg": 1221,
	"./fUSD.png": 1222,
	"./fUSDT.png": 1223,
	"./fWINGS.svg": 1224,
	"./gOHM.png": 1225,
	"./ibBTC.svg": 1226,
	"./ironICE.svg": 1227,
	"./jCHF.png": 1228,
	"./jEUR.png": 1229,
	"./jGBP.png": 1230,
	"./jJPY.png": 1231,
	"./jNZD.svg": 1232,
	"./mUSDC.svg": 1233,
	"./mUSDT.svg": 1234,
	"./miMatic.png": 1235,
	"./newQUICK.svg": 1236,
	"./pAVAX.svg": 1237,
	"./pBNB.svg": 1238,
	"./pBREW.png": 1239,
	"./pFTM.svg": 1240,
	"./pMATIC.svg": 1241,
	"./pOPEN.png": 1242,
	"./pWINGS.png": 1243,
	"./polyBUNNY.png": 1244,
	"./polyWISE.png": 1245,
	"./rUSD.svg": 1246,
	"./renBTC.png": 1247,
	"./renBTC.svg": 1248,
	"./renDGB.svg": 1249,
	"./renDOGE.png": 1250,
	"./sALPACA.svg": 1251,
	"./sAVAX.png": 1252,
	"./sFTMx.png": 1253,
	"./sSPELL.png": 1254,
	"./stKSM.png": 1255,
	"./stMATIC.png": 1256,
	"./wMEMO.png": 1257,
	"./wsHEC.png": 1258,
	"./wsSPA.png": 1259,
	"./xBOO.png": 1260,
	"./xMARK.png": 1261,
	"./xSCREAM.png": 1262,
	"./xTRI.svg": 1263,
	"./xVOLT.svg": 1264,
	"./xYELD.svg": 1265,
	"./xcDOT.png": 1266,
	"./xcKSM.png": 1267,
	"./xcRMRK.png": 1268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2058;